module.exports = __webpack_public_path__ + "static/media/audio-test.9919aa1e.mp3";